module.exports = __webpack_public_path__ + "static/media/1selfmanage.099c699a.png";